import { useEffect } from "react";
import { ErrorMsg } from "../ErrorMsg";
import { mainStore } from "../../mainStore";
import { FairnessModal } from "../FairnessModal";
import { InfoSection } from "../InfoSection";
import { observer } from "mobx-react-lite";
import { currencySymbols } from "../../constants/currencySymbols";
import { gameComponentsByGameId } from "../../constants/gameComponentsByGameId";
import { OddsHistorySection } from "../OddsHistorySection";
import { keyboardStore } from "../../mainStore/keyBoardStore";
import { GAME_IDS } from "../../constants/gameIds";

export const MobileApplicationWrapper = observer(() => {
  useEffect(() => {
    window.addEventListener("load", scaleApplicationWrapper);
    window.addEventListener("resize", scaleApplicationWrapper);

    return () => {
      window.removeEventListener("load", scaleApplicationWrapper);
      window.removeEventListener("resize", scaleApplicationWrapper);
    };
  }, []);

  const SelectedGameComponents = {
    GameName: gameComponentsByGameId[mainStore.gameId].GameName,
    BettingSection: gameComponentsByGameId[mainStore.gameId].BettingSection,
    GameSection: gameComponentsByGameId[mainStore.gameId].GameSection,
  };

  useEffect(() => {
    SelectedGameComponents.GameName = gameComponentsByGameId[mainStore.gameId].GameName;
    SelectedGameComponents.BettingSection = gameComponentsByGameId[mainStore.gameId].BettingSection;
    SelectedGameComponents.GameSection = gameComponentsByGameId[mainStore.gameId].GameSection;
    scaleApplicationWrapper();
  }, []);

  useEffect(() => {
    scaleApplicationWrapper();
  }, [keyboardStore.isOpen]);

  return (
    <div className="mobile-main-wrapper">
      <div className="application-wrapper">
        {mainStore.fairnessSectionOpened && <FairnessModal />}
        {mainStore.infoSectionOpened && <InfoSection />}
        <div className="balance-section-wrapper">
          {mainStore.skin.logo ? (
            <img src={mainStore.skin.logo} alt="" />
          ) : mainStore.gameId === 23 ? (
            <img src={"./assets/chicken/logo.png"} alt="" />
          ) : mainStore.gameId === 25 ? (
            <img src={"./assets/chicken-winter/logo-mb.png"} alt="" />
          ) : mainStore.gameId === 27 ? (
            <img src={"./assets/plinko-aztec/logo.webp"} alt="" />
          ) : mainStore.gameId === 28 ? (
            <img src={"./assets/limbo-rocket/logo.webp"} alt="" />
          ) : mainStore.gameId === 37 ? (
            <img src={"./assets/chicken-christmas/logo.webp"} alt="" />
          ) : mainStore.gameId === 40 ? (
            <img src={"./assets/tower-crash/images/logo.webp"} alt="" />
          ) : mainStore.gameId === 45 ? (
            <img src={"./assets/balloon/images/logo.webp"} alt="" />
          ) : mainStore.gameId === GAME_IDS.CONTAINER_CRASH ? (
            <img src={"./assets/container-crash/images/logo.webp"} alt="" />
          ) : mainStore.gameId === GAME_IDS.CHICKEN_FOOTBALL ? (
            <img src={"./assets/chicken-football/images/logo.webp"} alt="" />
          ) : mainStore.gameId === GAME_IDS.CANDY_TOWER ? (
            <img src={"./assets/candy-tower/images/logo.webp"} alt="" />
          ) : mainStore.gameId === GAME_IDS.HALLOWEEN_MINES ? (
            <img src={"./assets/halloween-mines/images/logo.webp"} alt="" />
          ) : mainStore.gameId === GAME_IDS.COIN_FLIP ? (
            <img src={"./assets/coin-flip/images/logo.webp"} alt="" />
          ) : (
            <p className={"game-title"}>{SelectedGameComponents.GameName}</p>
          )}
          <div className="balance-info-mobile">
            <svg
              className="balance-icon-mobile"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M21 12V7H5a2 2 0 0 1 0-4h14v4" />
              <path d="M3 5v14a2 2 0 0 0 2 2h16v-5" />
              <path d="M18 12a2 2 0 0 0 0 4h4v-4z" />
            </svg>
            <span className="balance-value-mobile">
              {currencySymbols[mainStore.currency]} {mainStore.balance}
            </span>
          </div>
        </div>
        <div className="game-wrapper">
          <ErrorMsg />
          <OddsHistorySection />
          <SelectedGameComponents.GameSection />
        </div>
        <div className="betting-section-wrapper">
          <SelectedGameComponents.BettingSection />
        </div>
      </div>
    </div>
  );
});

const scaleApplicationWrapperWithScroll = () => {
  const appWrapper = document.querySelector(".application-wrapper");
  const computedStyle = window.getComputedStyle(appWrapper);

  let scaleX;

  if (computedStyle.transform === "none") {
    scaleX = 1;
  } else {
    scaleX = parseFloat(computedStyle.transform.match(/matrix\(([^,]+),/)[1]);
  }

  const rect = appWrapper.getBoundingClientRect();
  const originalWidth = rect.width / scaleX;
  const scaleWidth = window.innerWidth / originalWidth;
  const scale = scaleWidth * 0.99; // Scale based only on width

  // Apply the horizontal scaling
  appWrapper.style.transform = `scale(${scale})`;
  appWrapper.style.transformOrigin = "top left";

  // Center the app horizontally
  const offsetX = (window.innerWidth - originalWidth * scale) / 2;
  appWrapper.style.marginLeft = `${offsetX}px`;

  // Constrain the mobile wrapper height to avoid extra scrollable space
  requestAnimationFrame(() => {
    const mobileWrapper = document.querySelector(".mobile-main-wrapper");
    // const appHeight = appWrapper.getBoundingClientRect().height * scale;
    mobileWrapper.style.height = `${appWrapper.getBoundingClientRect().height}px`;
    mobileWrapper.style.marginTop =
      Math.max(
        0,
        appWrapper.getBoundingClientRect().height -
          document.getElementById("application-body").getBoundingClientRect().height
      ) + "px";
  });
};

const scaleApplicationWrapperWithFit = () => {
  const appWrapper = document.querySelector(".application-wrapper");
  const computedStyle = window.getComputedStyle(appWrapper);

  let scaleX, scaleY;

  if (computedStyle.transform === "none") {
    scaleX = 1;
    scaleY = 1;
  } else {
    scaleX = parseFloat(computedStyle.transform.match(/matrix\(([^,]+),/)[1]);
    scaleY = parseFloat(computedStyle.transform.match(/matrix\([^,]+, [^,]+, [^,]+, ([^,]+),/)[1]);
  }

  const rect = appWrapper.getBoundingClientRect();
  const originalWidth = rect.width / scaleX;
  const originalHeight = rect.height / scaleY;
  const scaleWidth = window.innerWidth / originalWidth;
  const scaleHeight = window.innerHeight / originalHeight;
  const scale = Math.min(scaleWidth, scaleHeight) * 0.99;
  appWrapper.style.transform = `scale(${scale})`;
  appWrapper.style.transformOrigin = "top left";
  const offsetX = (window.innerWidth - originalWidth * scale) / 2;
  const offsetY = (window.innerHeight - originalHeight * scale) / 2;
  appWrapper.style.marginLeft = `${offsetX}px`;
  appWrapper.style.marginTop = `${offsetY}px`;
};

const fitScaleIds = [GAME_IDS.TWIST, GAME_IDS.TWIST_CLASSIC];

export const scaleApplicationWrapper = () => {
  if (fitScaleIds.includes(mainStore.gameId)) {
    scaleApplicationWrapperWithFit();
  } else {
    scaleApplicationWrapperWithScroll();
  }
};
